<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">添加分类</h1>
            <el-form class="form-container" :model="info" :rules="rules" ref="userInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">分类名称</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入分类名称"  v-model="info.name">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('userInfoForm')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import { addCategories } from '@/service/news'
    import {validateChat} from '@/utils/validate'
    export default {
        name: "add",
        components: {
            PopoverRight
        },
        data () {
            return {
                info: {
                    name: '',
                },
                rules: {
                    name: [
                        { required: true, message: '请填写分类名', trigger: 'blur' },
                        {validator:validateChat,type:4, trigger: 'blur',result:'分类名'},
                        { min: 4, max: 15, message: '长度在 4 到 15 个字符', trigger: 'blur' }
                    ],
                },
            }
        },
        props: {
            callback: Function
        },
        methods : {
            async open () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.resetForm();
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide();
                this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate();
            },
            resetForm () {
                this.info = {
                    name: '',
                }
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        let query = {
                            name:this.info.name,
                        }
                        addCategories(query).then((data) => {
                            this.$message({
                                message: '添加成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.resetForm()
                            this.hide()
                            this.callback && this.callback();
                        }).catch(err => {
                            this.$message({
                                message: err.message || '添加失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>
